// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"navbar_menuBar__nvIFL","title":"navbar_title__1TKq7","actions":"navbar_actions__1BXxP","actionsItems":"navbar_actionsItems__3rnjs"};